import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, input, model } from '@angular/core';
import { FormArray } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Budget } from '@tran-monorepo/interfaces/applications';
import { BudgetFormGroup, BudgetsComponent, BudgetsFormHelpers } from '../../form/budgets';
import {
    PillCellComponent,
    PillHeaderCellComponent,
    PillHeaderRowComponent,
    PillRowComponent,
    PillTableComponent
} from '../../pill-table';
import { ApplicationDetailDashboardBoxComponent } from '../application-detail-dashboard-box/application-detail-dashboard-box.component';

@Component({
    selector: 'tran-application-detail-budget',
    imports: [
        ApplicationDetailDashboardBoxComponent,
        TranslateModule,
        PillTableComponent,
        PillHeaderRowComponent,
        PillRowComponent,
        PillHeaderCellComponent,
        PillCellComponent,
        CurrencyPipe,
        BudgetsComponent
    ],
    templateUrl: './application-detail-budget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationDetailBudgetComponent {
    public readonly heading = input<string>(
        'components.application-detail-dashboard.application-detail-budget.heading'
    );
    public readonly isLoading = model<boolean>(false);
    public readonly budgets = input<Budget[]>([]);
    public readonly readonly = input<boolean>(false);

    public readonly control = input<FormArray<BudgetFormGroup>>();

    protected readonly totalBudget = computed(() => this.budgets().reduce((sum, budget) => sum + budget.amount, 0));

    constructor() {
        effect(() => this.patchValues(this.budgets(), this.control()));
    }

    private patchValues(budgets: Budget[], control?: FormArray<BudgetFormGroup>): void {
        if (!control) return;
        control.clear({ emitEvent: false });
        budgets.map(budget => {
            control.push(BudgetsFormHelpers.createBudgetFormGroup(budget.fiscalYear, budget.amount, budget.id ?? null));
        });
    }
}
